// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"summercamp_buttonsContainer__+r9lr","mainContainer":"summercamp_mainContainer__7Rhn6"};